import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import IranFlag from "../../assets/images/iran.webp";
import api from "../../api";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../css/cover.css';
import '../../css/styles.css';
import moment from "moment-jalaali";
import LoadingSpinner from "../Loading";
import {toast} from "react-toastify";
import {IconButton} from "@material-ui/core";
import {Delete} from "@material-ui/icons";
import {e2p, p2e} from "../../utils/utils";


function Payment() {
    const [car, setCar] = useState(null);
    const [payments, setPayments] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [newPayment, setNewPayment] = useState({
        description: '',
        amount: '',
    });
    
    const {carId} = useParams();
    const {requestId} = useParams();
    
    useEffect(() => {
        setIsLoading(true);
        
        async function fetchPayments() {
            const response = await api.get(`/repair-request/payments/${requestId}`);
            const payments = response.data.data
            if (payments.length > 0)
                payments.map((payment) => {
                    payment['createdAt'] = moment(payment.date)
                        .locale('fa')
                        .format('jYYYY/jMM/jDD HH:mm');
                })
            setPayments(payments)
            setIsLoading(false);
        }
        
        fetchPayments();
        
        async function fetchCar() {
            setIsLoading(true);
            const response = await api.get(`/car/${carId}`);
            setCar(response.data.data);
            setIsLoading(false);
        }
        
        fetchCar();
        
    }, []);
    
    const handleCreatePayment = async (e) => {
        e.preventDefault();
        if (!parseInt(p2e(newPayment.amount))) {
            toast.error('لطفا مبلغ را وارد کنید.');
            return;
        }
        
        const requestData = {
            repair_request_id: requestId,
            description: newPayment.description,
            amount: p2e(newPayment.amount)
        }
        setIsLoading(true);
        
        try {
            const response = await api.post('/payment', requestData);
            toast.success('پرداخت با موفقیت اضافه شد.')
            setPayments([...payments, {
                id: response.data.data.id,
                description: response.data.data.description,
                amount: response.data.data.amount,
                createdAt: moment(response.data.data.date)
                    .locale('fa')
                    .format('jYYYY/jMM/jDD HH:mm')
            }])
        } catch (error) {
            toast.error(error.response.data.message);
        } finally {
            setIsLoading(false);
        }
    }
    
    const handleDeleteClick = (paymentId) => {
        setIsLoading(true);
        api.delete(`/payment/${paymentId}`)
            .then(response => {
                setIsLoading(false);
                toast.success('پرداخت موردنظر با موفقیت حذف شد.')
                setPayments(payments.filter(payment => payment.id !== paymentId));
            })
            .catch(error => {
                toast.error(error.response.data.message);
            });
    };
    
    return (
        <div>
            {isLoading ? <LoadingSpinner/> :
                <div className="content-wrapper">
                    <div className="container-xxl flex-grow-1 container-p-y">
                        {car &&
                            <div className="row d-block justify-content-center g-0">
                                <div className="row mx-auto pelak g-0 mb-3 mt-3" style={{width: '20rem'}}>
                                    <div className="col">
                                        <div className="row my-auto">
                                            <div className="col border-start border-end-0">
                                                <p className="text-center fw-bold iranNo">ایران</p>
                                                <div>
                                                    <p className="border-0 text-center">{car?.plate.slice(7, 9)}</p>
                                                </div>
                                            </div>
                                            <div className="col my-auto">
                                                <p className="border-0 text-center">{car?.plate.slice(3, 6)}</p>
                                            </div>
                                            <div className="col my-auto">
                                                <p className="border-0 text-center">{car?.plate.slice(2, 3)}</p>
                                            </div>
                                            <div className="col my-auto">
                                                <p className="border-0 text-center">{car?.plate.slice(0, 2)}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-auto leftSide">
                                        <div className="flag">
                                            <img src={IranFlag} alt="iran's flag"/>
                                        </div>
                                        <div className="iranText text-center">
                                            <p>I.R.</p>
                                            <p>IRAN</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {car &&
                            <div className="row justify-content-center">
                                <div className="col-12 col-sm-12 col-md-8 col-lg-6 col-xl-6 col-xxl-6">
                                    <div className="card rounded-4 border-3 border-dark mb-4">
                                        <h5 className="card-header bg-dark text-white text-center">افزودن پرداخت
                                            جدید</h5>
                                        <div className="card-body">
                                            <form action="">
                                                <div className="mb-3">
                                                    <label htmlFor="description" className="form-label">توضیحات</label>
                                                    <input
                                                        required
                                                        type="text"
                                                        id="description"
                                                        className="form-control shadow"
                                                        name="description"
                                                        maxLength="50"
                                                        value={newPayment.description}
                                                        onChange={(e) => {
                                                            setNewPayment({
                                                                ...newPayment,
                                                                description: e.target.value
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className="mb-3">
                                                    <label htmlFor="amount" className="form-label">مبلغ (تومان)</label>
                                                    <input
                                                        required
                                                        type="text"
                                                        id="amount"
                                                        maxLength={15}
                                                        className="form-control shadow"
                                                        name="amount"
                                                        value={newPayment.amount}
                                                        onChange={(e) => {
                                                            setNewPayment({
                                                                ...newPayment,
                                                                amount: e.target.value
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className="d-grid gap-2">
                                                    <input
                                                        type="submit"
                                                        className="btn btn-warning me-1"
                                                        name="submit"
                                                        value="ثبت"
                                                        onClick={handleCreatePayment}
                                                        disabled={isLoading}
                                                    />
                                                </div>
                                            </form>
                                        </div>
                                        <h5 className="card-header bg-dark text-white text-center">لیست پرداخت ها</h5>
                                        <div className="card-body">
                                            <table className="table table-bordered">
                                                {payments.map((payment, index) => (
                                                    <tbody>
                                                    <tr>
                                                        <td className="text-center">{index + 1}</td>
                                                        <td className="text-center">{payment.description}</td>
                                                        <td className="text-center">{e2p(payment.createdAt).replace(' ', ' - ')}</td>
                                                        <td className="text-center">{e2p(payment.amount?.toLocaleString()) ?? ''} تومان</td>
                                                        <td className="text-center">
                                                            <IconButton disabled={isLoading}
                                                                        onClick={() => handleDeleteClick(payment.id)}>
                                                                <Delete color="secondary"/>
                                                            </IconButton>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                ))}
                                            </table>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div
                                            className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4 d-grid gap-2">
                                            <input
                                                type="button"
                                                className="btn btn-info"
                                                name="button1"
                                                value="گزارشات"
                                                onClick={() => {
                                                    window.location.href = `/reports`
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    )
}

export default Payment;
